import classNames from "classnames";
import StyledButton from "../../common/buttons/StyledButton";
import BaseModal from "../../common/modals/BaseModal/BaseModal";
import ModalCloseButton from "../../common/modals/ModalCloseButton/ModalCloseButton";
import styles from "./PartialSuccessMessagesModal.module.css";

const strings = {
  title: "Notice",
  ok: "Ok",
};

type Props = {
  partialSuccessMessages: string[];
  onRequestClose: () => void;
  className?: string;
};

export default function PartialSuccessMessagesModal({
  partialSuccessMessages,
  onRequestClose,
  className,
}: Props) {
  return (
    <BaseModal
      className={classNames(styles.modal, className)}
      label={strings.title}
      isOpen={partialSuccessMessages.length > 0}
      onRequestClose={onRequestClose}
    >
      <div className={styles.header}>
        <div className={styles.title}>{strings.title}</div>
        <ModalCloseButton onClick={onRequestClose} />
      </div>
      <div className={styles.body}>{partialSuccessMessages.join("\n\n")}</div>
      <StyledButton className={styles.okButton} onClick={onRequestClose}>
        {strings.ok}
      </StyledButton>
    </BaseModal>
  );
}
